$('.resources').each(function(){
    resHeight = $(this).outerHeight();
    $('.card-img').css('height', resHeight*.55)
});
$(function(){  
  
    var mql = window.matchMedia("(min-width: 1023px)")
  
    mediaqueryresponse(mql)
  
    mql.addListener(mediaqueryresponse)
  
    function mediaqueryresponse(mql) {
      if (mql.matches) {   
        $('.resources').each(function(){
            resHeight = $(this).outerHeight();
            $('.card-img').css('height', resHeight*.55)
        });
      }else{
        $('.resources').each(function(){
            resHeight = $(this).find('.card-content').outerHeight();
            $('.card-img').css('height', resHeight*.50)
        });
      }
    } 
  });